// * GET =====================================
export const COMPANY_GET = (companyId: string) => `/company/${companyId}`;

export const COMPANY_GET_ADMIN_ROLES = `/company/admin_roles`;

export const COMPANY_GET_USER_ROLES = `/company/user_roles`;

export const COMPANY_GET_EMAIL_TEMPLATES = `/company/email_templates`;

export const COMPANY_GET_CATEGORIES = `/company/categories`;

export const COMPANY_GET_FEATURES = (companyId?: string) =>
  companyId ? `/company/${companyId}/features` : `/company/features`;

export const COMPANY_GET_USER_CATEGORY_TREE = `/company/user_category_tree`;

export const COMPANY_GET_GET_AVAILABLE_CONNECTOR_TYPES = `/company/get_available_connector_types`;

export const COMPANY_GET_STORIES = `/company/stories`;
// * PATCH ===================================

// * POST ====================================
export const COMPANY_POST_COPY_WORKSPACE = '/company/copy_workspace';

export const COMPANY_POST_CATEGORIES = `/company/categories`;

export const COMPANY_POST_CATEGORY = `/company/category`;

export const COMPANY_POST_CHANGE_OWNER = `/company/change_owner`;

export const COMPANY_POST_UPDATE = `/company/update`;
export const COMPANY_PUT_CREATE = `/company/create`;

export const COMPANY_POST_MASS_OPERATION = `/company/mass_operation`;

export const COMPANY_POST_PERMISSIONS = `/company/permissions`;

export const COMPANY_POST_DEFAULT_PERMISSIONS = `/company/default_permissions`;

export const COMPANY_POST_UPDATE_OBJECTS_PERMISSIONS = `/company/update_objects_permissions`;

export const COMPANY_POST_USER_TOGGLE = `/company/user_toggle`;
// * DELETE ==================================

// * PUT =====================================
